/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import { connect } from 'react-redux';
// actions
import { setPartnerLogoSrc, setPartnerLogoUrl } from 'state/actions/embedsState/embedManagementState/selected_embed_status';
import { setPreviewImage } from 'state/actions/embedsState/embedManagementState/content_status';
import { sendMessage} from '@insticator/insticator-ui'; // iui-state
// component
import ImageUpload from 'material/imageupload/imageupload';



/* ========== ~~~~~~~~~~ IMAGE UPLOAD : CONTAINER ~~~~~~~~~~ ========== */
// map state
const mapStateToProps = () => ({

});

const mapDispatchToProps = dispatch => ({
    sendMessage: message => dispatch(sendMessage(message))
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ImageUpload);
